export class LicensingItemsFilter {
  accountNo: string;
  accountName: string;
  txtAccountNo: string;
  vendor: string;
  licenseNumber: string;
  licenseStatus: string;
  accountCity: string;
  accountState: string;
  parentAccountNo: string;
  dsm: string;
  sel: string;
  growerName: string;
  growerCity: string;
  growerState: string;
  growerOrderNo: string;
  showAllLicences: boolean;
}
